import { render, staticRenderFns } from "./ThreeParallels.vue?vue&type=template&id=4f47b836&scoped=true&"
import script from "./ThreeParallels.vue?vue&type=script&lang=js&"
export * from "./ThreeParallels.vue?vue&type=script&lang=js&"
import style0 from "./ThreeParallels.vue?vue&type=style&index=0&id=4f47b836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f47b836",
  null
  
)

export default component.exports